module.exports = __webpack_public_path__ + "assets/favicons/sub-nav-sidebar-toggle.svg";